module.exports = __webpack_public_path__ + "img/spongebob_squarepants_characters_scan-editted.6ad63cb7.jpg";